import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./motion";
import { PHONE, PHONE_HREF } from "../lib/site";

export const QuoteCTA = ({ title = "Let's scope your facility." }) => (
  <section className="relative overflow-hidden bg-porcelain py-28 md:py-40" data-testid="quote-cta-section">
    <div className="glow-orb absolute -right-40 top-10 h-[480px] w-[480px]" aria-hidden="true" />
    <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal><Eyebrow>Next step</Eyebrow></Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-4xl font-display text-5xl font-semibold leading-[0.95] tracking-tight text-ink md:text-7xl lg:text-8xl">
          {title}
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-8 max-w-xl text-base text-slate-600 md:text-lg">
          Tell us about your space. We review every request and reply with next steps — a walkthrough or consultation, then a written proposal.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link to="/request-quote" data-testid="cta-request-quote-btn" className="btn-ink group">
            Request a Free Cleaning Quote <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
          <a href={PHONE_HREF} data-testid="cta-call-btn" className="btn-outline-ink"><Phone className="h-4 w-4" /> {PHONE}</a>
        </div>
      </Reveal>
    </div>
  </section>
);
